/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-03-11 16:11:07
 *
 *******************************************************/
// @flow

import React from 'react';
export function InsightIcon(props) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.5999 8.80039C5.5999 8.35856 5.95807 8.00039 6.3999 8.00039C6.84173 8.00039 7.1999 8.35856 7.1999 8.80039V12.8004C7.1999 13.2422 6.84173 13.6004 6.3999 13.6004C5.95807 13.6004 5.5999 13.2422 5.5999 12.8004V8.80039Z"
        fill="#8C9196"
      />
      <path
        d="M8.7999 4.80039C8.7999 4.35856 9.15808 4.00039 9.5999 4.00039C10.0417 4.00039 10.3999 4.35856 10.3999 4.80039V12.8004C10.3999 13.2422 10.0417 13.6004 9.5999 13.6004C9.15808 13.6004 8.7999 13.2422 8.7999 12.8004V4.80039Z"
        fill="#8C9196"
      />
      <path
        d="M11.9999 3.20039C11.9999 2.75856 12.3581 2.40039 12.7999 2.40039C13.2417 2.40039 13.5999 2.75856 13.5999 3.20039V12.8004C13.5999 13.2422 13.2417 13.6004 12.7999 13.6004C12.3581 13.6004 11.9999 13.2422 11.9999 12.8004V3.20039Z"
        fill="#8C9196"
      />
      <path
        d="M2.3999 6.40039C2.3999 5.95856 2.75807 5.60039 3.1999 5.60039C3.64173 5.60039 3.9999 5.95856 3.9999 6.40039V12.8004C3.9999 13.2422 3.64173 13.6004 3.1999 13.6004C2.75807 13.6004 2.3999 13.2422 2.3999 12.8004V6.40039Z"
        fill="#8C9196"
      />
    </svg>
  );
}
